import { styled } from '../../shared/theming-sc'

const KebabMenuOuter = styled.div`
    position: relative;
    z-index: 1000000;
    width: 30px;
    float: right;
`

const KebabmenuTrigger = styled.button`
    display: inline-block;
    position: relative;
    background-color: transparent;
    border: 0;
    min-width: auto;
    cursor: pointer;
    outline: none;
`

const KebabMenuWrapper = styled.div`
    width: auto;
    height: auto;
    position: absolute;
    bottom: 10px;
    left: -110px;
`

const KebabMenuBody = styled.div`
    position: relative;
    background: white;
    border: 1px solid #dddddd;
    border-radius: 5px;
    box-shadow: 5px 5px 4px 0 rgba(0, 0, 0, 0.2);
    padding: 15px 20px;
    text-align: left;
`

export { KebabMenuOuter, KebabmenuTrigger, KebabMenuBody, KebabMenuWrapper }
